export default __webpack_public_path__ + "static/media/slide_1.da2a3a38.jpg";